import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function PolygonIcon() {
  return (
    <svg
      width="6"
      height="13"
      viewBox="0 0 6 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-2.84124e-07 6.5L5.25 0.870834L5.25 12.1292L-2.84124e-07 6.5Z"
        fill="#252525"
      />
    </svg>
  )
}

export default function ViewFile360Icon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={() => PolygonIcon()} {...props} />
}
